export async function closeWithFallback ({ tryOffline, isReallyOnline, closeOnline, onFallback, onError }) {
  try {
    await tryOffline()
    return 'offline'
  } catch (e) {
    if (await isReallyOnline()) {
      onFallback?.(e)
      await closeOnline()
      return 'online-fallback'
    }
    onError(e)
    return 'error'
  }
}
